export default {
  tabs: {
    legalTender: "法幣匯總",
    virtualCoin: "虛擬幣匯總",
    transactionDetails: "交易詳情",
  },
  download: {
    filename: "數據明細",
  },
};
